import { render, staticRenderFns } from "./Leftmenu.renew.vue?vue&type=template&id=2b126b80&scoped=true&"
import script from "./Leftmenu.renew.vue?vue&type=script&lang=js&"
export * from "./Leftmenu.renew.vue?vue&type=script&lang=js&"
import style0 from "./Leftmenu.renew.vue?vue&type=style&index=0&id=2b126b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b126b80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_dev\\workspace_front\\aikl_v2_front_kcc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b126b80')) {
      api.createRecord('2b126b80', component.options)
    } else {
      api.reload('2b126b80', component.options)
    }
    module.hot.accept("./Leftmenu.renew.vue?vue&type=template&id=2b126b80&scoped=true&", function () {
      api.rerender('2b126b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/Leftmenu.renew.vue"
export default component.exports